<template>
	<div>
		<header-fixed></header-fixed>
		<div class="main-top">
			<div id="main-content-area" class="container">
				<div class="row no-gutters">
					<div id="main-content" class="col-lg-9 col-xl-9 order-lg-12">
						<div id="salon-container" class="container">
							<div class="row">
								<div class="col-12">
									<div class="tab-content">
										<!-- nadzorna ploca -->
										<!--<div class="tab-pane fade show active" id="biz-nadzorna" role="tabpanel">
											<dashboard></dashboard>
										</div>-->
										<!-- rezervacije -->
										<!--
										<div class="tab-pane fade show active" id="biz-termini" role="tabpanel">
											<termini></termini>
										</div>
										-->
										<!-- raspored -->
										<div class="tab-pane fade" id="biz-raspored" role="tabpanel">
											<schedule></schedule>
										</div>
										<!-- komentari -->
										<div class="tab-pane fade" id="biz-komentari" role="tabpanel">
											<comments></comments>
										</div>
										<!-- usluge -->
										<div class="tab-pane fade" id="biz-usluge" role="tabpanel">
											<service></service>
										</div>
										<!-- galerija -->
										<div class="tab-pane fade" id="biz-galerija" role="tabpanel">
											<gallery></gallery>
										</div>
										<!-- salon -->
										<div class="tab-pane fade" id="biz-salon" role="tabpanel">
											<salon></salon>
										</div>
										<!-- zaposlenici -->
										<div class="tab-pane fade" id="biz-zaposlenici" role="tabpanel">
											<employee></employee>
										</div>
										<!-- postavke -->
										<div class="tab-pane fade" id="biz-postavke" role="tabpanel">
											<profile></profile>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div id="side-content" class="col-lg-3 col-xl-3 pb-5 order-lg-1 d-none d-lg-block">
						<div class="salon-container container stickey-top">
							<div class="nav navbar-nav user-menu-vert" role="tablist">					
								<!-- <a id="nadzorna" class="nav-item nav-link active" data-toggle="pill" href="#biz-nadzorna" role="tab"><span class="fas fa-tachometer-alt fa-fw"></span>Nadzorna ploča</a>-->
								<a id="nova-rezervacija" class="d-none" data-toggle="pill" href="#biz-galerija" role="tab"><span class="far fa-calendar-check fa-fw"></span>Rezervacije</a>
								<!-- <a id="terminiNav" class="nav-item nav-link" data-toggle="pill" href="#biz-termini" role="tab"><span class="far fa-calendar-check fa-fw"></span>Rezervacije</a> -->
								<a id="raspored" class="nav-item nav-link" data-toggle="pill" href="#biz-raspored" role="tab"><span class="far fa-calendar-alt fa-fw"></span>Raspored</a>
								<a id='komentari' class="nav-item nav-link" data-toggle="pill" href="#biz-komentari" role="tab"><span class="far fa-comments fa-fw"></span>Komentari</a>
								<a id='usluge' class="nav-item nav-link" data-toggle="pill" href="#biz-usluge" role="tab"><span class="fas fa-hand-holding-usd fa-fw"></span>Usluge</a>
								<a id='galerija' class="nav-item nav-link" data-toggle="pill" href="#biz-galerija" role="tab"><span class="far fa-images fa-fw"></span>Galerija</a>
								<a id='salon' class="nav-item nav-link" data-toggle="pill" href="#biz-salon" role="tab"><span class="fas fa-store-alt fa-fw"></span>Salon</a>
								<a id='zaposlenici' class="nav-item nav-link" data-toggle="pill" href="#biz-zaposlenici" role="tab"><span class="fas fa-user-friends fa-fw"></span>Djelatnici</a>
								<a id='postavke' class="nav-item nav-link" data-toggle="pill" href="#biz-postavke" role="tab"><span class="fas fa-cog fa-fw"></span>Postavke profila</a>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="modal animated fadeIn" id="newResModal" tabindex="-1" role="dialog" aria-labelledby="bookModalLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered" role="document">
					<div class="modal-content">
						<div class="modal-header text-center">
							<h4 class="modal-title w-100 font-weight-bold">Novi termin</h4>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body mx-3">
							<form id="" action="" method="post">
								<div class="row">
									<div class="col-6 input-group mb-3">
										<div class="input-group-prepend">
											<span class="input-group-text" id="basic-addon1"><i class="far fa-calendar-alt fa-fw"></i></span>
										</div>
										<input id="datum" name="datum" type="text" class="form-control" placeholder="Datum" aria-label="datum" aria-describedby="datum" required>
									</div>
									<div class="col-6 input-group mb-3">
										<div class="input-group-prepend">
											<span class="input-group-text" id="basic-addon1"><i class="far fa-clock fa-fw"></i></span>
										</div>
										<input id="vrijeme" name="vrijeme" type="text" class="form-control" placeholder="Vrijeme" aria-label="name" aria-describedby="basic-addon1" required>
									</div>
								</div>
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<span class="input-group-text" id="basic-addon1"><i class="fa fa-user fa-fw"></i></span>
									</div>
									<input id="klijent" name="klijent" type="text" class="form-control" placeholder="Klijent" aria-label="klijent" aria-describedby="basic-addon1" required>
								</div>
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<span class="input-group-text" id="basic-addon1"><i class="fas fa-hand-holding-usd fa-fw"></i></span>
									</div>
									<input id="usluga" name="usluga" type="text" class="form-control" placeholder="Usluga" aria-label="klijent" aria-describedby="basic-addon1" required>
								</div>
								<button id="submit" name="submit" class="fs-btn dark text-uppercase btn-lg btn-block">Spremi</button>
							</form>
						</div>
						<div id="book-modal-footer" class="modal-footer">
						</div>
					</div>
				</div>
			</div>
			<div class="modal animated fadeIn" id="newPretModal" tabindex="-1" role="dialog" aria-labelledby="bookModalLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered" role="document">
					<div class="modal-content">
						<div class="modal-header text-center">
							<h4 class="modal-title w-100 font-weight-bold">Nova pretplata</h4>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body mx-3">
							<form id="" action="" method="post">
								<div class="row">
									<div class="col-6 input-group mb-3">
										<div class="input-group-prepend">
											<span class="input-group-text" id="basic-addon1"><i class="far fa-calendar-alt fa-fw"></i></span>
										</div>
										<input id="datum" name="datum" type="text" class="form-control" placeholder="Datum" aria-label="datum" aria-describedby="datum" required>
									</div>
									<div class="col-6 input-group mb-3">
										<div class="input-group-prepend">
											<span class="input-group-text" id="basic-addon1"><i class="far fa-clock fa-fw"></i></span>
										</div>
										<input id="vrijeme" name="vrijeme" type="text" class="form-control" placeholder="Vrijeme" aria-label="name" aria-describedby="basic-addon1" required>
									</div>
								</div>
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<span class="input-group-text" id="basic-addon1"><i class="fa fa-user fa-fw"></i></span>
									</div>
									<input id="klijent" name="klijent" type="text" class="form-control" placeholder="Klijent" aria-label="klijent" aria-describedby="basic-addon1" required>
								</div>
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<span class="input-group-text" id="basic-addon1"><i class="fas fa-hand-holding-usd fa-fw"></i></span>
									</div>
									<input id="usluga" name="usluga" type="text" class="form-control" placeholder="Usluga" aria-label="klijent" aria-describedby="basic-addon1" required>
								</div>
								<button id="submit" name="submit" class="fs-btn dark text-uppercase btn-lg btn-block">Spremi</button>
							</form>
						</div>
						<div id="book-modal-footer" class="modal-footer">
						</div>
					</div>
				</div>
			</div>
			<div class="modal animated fadeIn" id="editServModal" tabindex="-1" role="dialog" aria-labelledby="bookModalLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered" role="document">
					<div class="modal-content">
						<div class="modal-header text-center">
							<h4 class="modal-title w-100 font-weight-bold">Uredi uslugu</h4>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body mx-3">
							<form id="" action="" method="post">
								<div class="row">
									<div class="col-12 mb-3">
										<input id="servName" name="servName" type="text" class="form-control" placeholder="Usluga" aria-label="usluga" aria-describedby="usluga" required>
									</div>
									<div class="col-12 mb-3">
										<textarea class="form-control" id="servArea" rows="3" placeholder="kratki opis usluge" aria-label="opis usluge" aria-describedby="opis usluge" required></textarea>
									</div>
									<div class="col-6 mb-3">
										<input id="servPrice" name="servPrice" type="number" class="form-control" placeholder="Cijena" aria-label="cijena usluge" aria-describedby="cijena usluge" required>
									</div>
									<div class="col-6 mb-3">
										<input id="servTime" name="servTime" type="number" class="form-control" placeholder="Vrijeme (min)" aria-label="vrijeme trajanja" aria-describedby="vrijeme trajanja" required>
									</div>
									<div class="col-12 mb-3 text-center">
										<div class="form-check form-check-inline">
											<input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
											<label class="form-check-label" for="inlineCheckbox1">Istaknuto</label>
										</div>
										<div class="form-check form-check-inline">
											<input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
											<label class="form-check-label" for="inlineCheckbox1">Akcija</label>
										</div>
									</div>
								</div>
								<button id="submit" name="submit" class="fs-btn dark text-uppercase btn-lg btn-block">Spremi</button>
							</form>
						</div>
						<div id="book-modal-footer" class="modal-footer">
						</div>
					</div>
				</div>
			</div>
			<div class="modal animated fadeIn" id="delServModal" tabindex="-1" role="dialog" aria-labelledby="dekKomModal" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered" role="document">
					<div class="modal-content">
						<div class="modal-header text-center">
							<h4 class="modal-title w-100 font-weight-bold">Brisanje usluge</h4>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body mx-3">
							<div class="row">
								<div class="col-12 text-center mb-3">
									<h4>Jeste li sigurni da želite izbrisati uslugu?</h4>
								</div>
								<div class="col-12 text-center">
									<div class="btn-group">
										<a class="btn fs-btn dark mr-2">Izbriši</a>
										<a class="btn fs-btn primary">Odustani</a>
									</div>
								</div>
							</div>
						</div>
						<div id="book-modal-footer" class="modal-footer">
						</div>
					</div>
				</div>
			</div>
		</div>
		<image-viewer v-if="image_viewer"></image-viewer>
		<home-footer></home-footer>
	</div>
</template>

<script>
	import salon from './salon'
	import employee from './employee'
	import profile from './profile'
	import service from './service'
	import gallery from './gallery'
	import comments from './comments'
	// import termini from './termini'
	// import dashboard from './dashboard'
	import schedule from './schedule';
	import imageViewer from './imageviewer'

	import {
		mapState
	} from 'vuex'
	export default {
		name: 'vendor_termini',
		components: {
			'salon': salon,
			employee,
			profile,
			service,
			gallery,
			'image-viewer': imageViewer,
			comments,
			// dashboard,
			// termini,
			schedule
		},
		computed: {
			...mapState({
				image_viewer: (state) => state.image_viewer
			})
		},
		mounted() {
			var hash = this.$route.hash.replace('#', '');
			// console.log(hash);
			if (document.getElementById(hash)) {
				document.getElementById(hash).click();
			}
		},
		updated() {}
	}

</script>

<style>
	.saveBtn {
		width: 150px;
		border: none;
		background: #fc195d;
		display: block;
		margin-top: 20px;
	}

</style>
<style>

	.required {
		color: red;
	}

</style>
